<template>
  <div class="wechatauth2">
    <div v-if="!bindingErrorStatus" class="loadingWindowImg">
      <img src="../assets/img/loading.gif" alt="" />
    </div>
    <div v-if="bindingErrorStatus" class="loadingWindowText">
        <p>{{ $t("bindingErrorMessage") }}</p>
        <p :style="{textDecoration: 'underline', cursor: 'pointer'}" @click="$router.push('/')">{{ $t("returnHome") }}</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Router from "../router";
import { isUserAuthenticated } from "../store/modules/cart";

import axios from '@/api/http_client'
export default {
  name: "wechatauth2",
  data() {
    return {
      test: false,
      code: "",
      unionid: ""
    };
  },
  methods: {
    ...mapActions("auth", [
      "LoginRequest",
      "resetEmail",
      "sentVerificationCode",
      "resetPassword",
      "Auth2RequestToken",
    ]),
    ...mapMutations("auth", ["updateErrorMessage"]),
    initiateLogin() {
      const {code, unionid} = this
      if (code) {// web登录
        this.Auth2RequestToken({ token: code, type: "Wechat" });
        // store.dispatch('auth/fetchCustomerInformation', this.code);
        return
      }
      if (unionid) {// app登录
        this.Auth2RequestToken({ unionid, type: "Wechat" });
      }
    },
    initPageData() {
      const {code, unionid} = this.$route.query
      this.code = code;
      this.unionid = unionid;
      this.initiateLogin();
    }
  },
  //   beforeRouteLeave(to, from, next) {
  //     if (isUserAuthenticated()) {
  //       this.$store.dispatch("cart/getCart");
  //       this.$store.dispatch("auth/fetchCustomerInformation");
  //     } else {
  //       // this.$store.dispatch("cart/fetchCartProducts");
  //       // this.$store.dispatch("auth/fetchCustomerInformation");
  //     }
  //     next();
  //   },
  mounted() {
    // console.log("code 1", this.$route.query.code);
    this.initPageData()

    //   this.$route.query
    //   '$route.query': {
    //   immediate: true,
    //   handler(newVal) {
    //     this.fetchProductDetails(newVal.productNum);
    //     this.updateActiveProduct(newVal.productNum);
    //     this.$store.dispatch('products/fetchCustomCategories');
    //     this.initializeTabImg();
    //     this.currentURL = 'https://gvyummy.com' + this.$route.fullPath;
    //   }
    // },
  },
  watch: {
    $route(to, from) {
      // console.log("code 2", this.$route.query.code);
      if (to.path === "/wechat-auth2") {
        this.initPageData()
      }
    },
    // loginModalVisibilityGlobal: function(newVal, oldVal) {
    //     this.resetLoginForm();
    //     this.resetForgetPassword();
    // },
    // loggedIn: function(newVal, oldVal) {
    //     if (newVal === true) {
    //         this.toggleLoginModalVisibility(false);
    //     }
    // },
  },
  computed: mapState({
    loginModalVisibilityGlobal: (state) =>
      state.navbar.loginModalVisibilityGlobal,
    loggedIn: (state) => state.auth.loggedIn,
    bindingErrorStatus: (state) => state.auth.bindingErrorStatus,
  }),
};
</script>
​
​
<style scoped lang="less">
@import "../assets/css/public";
@import "../assets/css/wechatauth2";
</style>



// WEBPACK FOOTER //
// src/view/wechatauth2.vue